export default __webpack_public_path__ + "static/media/new-kingdom-points-tutorial-2x.8c9797b9.webp";